module.exports = __webpack_public_path__ + "img/market-rider-offline.8a34f315.png";